class ProductAccordionsModule {
  constructor(controller) {
    this.controller = controller;
    this.accordions = controller.queryAll('[data-product-accordion]');
    this.itemObservers = [];
    this.youtubeObservers = [];

    if (!this.accordions.length) return;

    this.init();
  }

  init() {
    this.accordions.forEach((accordion) => {
      accordion.querySelectorAll('.product-accordion__item').forEach((item) => {
        this.prepareDeferredYouTubeEmbeds(item);
        this.observeItem(item);
        this.setAccordionHeight(item);
      });

      accordion.querySelectorAll('[data-accordion-header]').forEach((header) => {
        header.addEventListener('click', () => {
          const item = header.closest('.product-accordion__item');
          if (!item) return;

          const isActive = item.classList.contains('product-accordion__item--active');
          accordion.querySelectorAll('.product-accordion__item').forEach((accordionItem) => {
            accordionItem.classList.remove('product-accordion__item--active');
            this.setAccordionHeight(accordionItem);
          });

          if (!isActive) {
            item.classList.add('product-accordion__item--active');
            this.updateDeferredYouTubeEmbeds(item);
            this.setAccordionHeight(item);
          }
        });
      });
    });

    window.addEventListener('resize', () => {
      this.accordions.forEach((accordion) => {
        accordion.querySelectorAll('.product-accordion__item').forEach((item) => {
          this.setAccordionHeight(item);
        });
      });
    });
  }

  observeItem(item) {
    const classObserver = new MutationObserver(() => {
      this.updateDeferredYouTubeEmbeds(item);
      this.setAccordionHeight(item);
    });

    classObserver.observe(item, {
      attributes: true,
      attributeFilter: ['class']
    });

    this.itemObservers.push(classObserver);

    const content = item.querySelector('[data-accordion-content]');
    if (!content) return;

    item.querySelectorAll('img, video, iframe').forEach((media) => {
      media.addEventListener('load', () => this.setAccordionHeight(item), { once: true });
      media.addEventListener('loadedmetadata', () => this.setAccordionHeight(item), { once: true });
    });

    if (typeof ResizeObserver === 'undefined') return;

    const resizeObserver = new ResizeObserver(() => {
      this.setAccordionHeight(item);
    });

    resizeObserver.observe(item.querySelector('.product-accordion__body') || content);
    this.itemObservers.push(resizeObserver);
  }

  prepareDeferredYouTubeEmbeds(item) {
    item.querySelectorAll('iframe[data-accordion-youtube-src]').forEach((iframe) => {
      if (iframe.dataset.accordionYoutubePrepared === 'true') return;

      iframe.dataset.accordionYoutubePrepared = 'true';
      iframe.setAttribute('loading', iframe.getAttribute('loading') || 'lazy');
      iframe.addEventListener('load', () => this.setAccordionHeight(item), { once: true });

      if (!('IntersectionObserver' in window)) {
        this.updateDeferredYouTubeEmbeds(item);
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || iframe.hasAttribute('src')) return;
          if (!item.classList.contains('product-accordion__item--active')) return;

          const deferredSrc = iframe.dataset.accordionYoutubeSrc;
          if (!deferredSrc) return;

          iframe.src = deferredSrc;
          observer.disconnect();
        });
      }, {
        root: null,
        rootMargin: '0px',
        threshold: 0.01,
      });

      observer.observe(iframe);
      this.youtubeObservers.push(observer);
    });
  }

  updateDeferredYouTubeEmbeds(item) {
    if (!item.classList.contains('product-accordion__item--active')) return;
    if ('IntersectionObserver' in window) return;

    item.querySelectorAll('iframe[data-accordion-youtube-src]:not([src])').forEach((iframe) => {
      const deferredSrc = iframe.dataset.accordionYoutubeSrc;
      if (!deferredSrc) return;

      iframe.src = deferredSrc;
    });
  }

  setAccordionHeight(item) {
    const content = item.querySelector('[data-accordion-content]');
    if (!content) return;

    if (item.classList.contains('product-accordion__item--active')) {
      content.style.setProperty('--accordion-content-height', `${content.scrollHeight}px`);
      return;
    }

    content.style.removeProperty('--accordion-content-height');
  }
}

window.HerbiProductSection.registerModule('accordions', (controller) => {
  return new ProductAccordionsModule(controller);
});
